module.exports = __webpack_public_path__ + "static/media/Button_Bookmark_2Active.bdd72980.png";